import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'web-library';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  button: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  dialogContainer:{}
}));

interface IExamCheckEmailDialogProps {
  modalState: boolean;
  onDialogConfirm: () => void;
  onDialogClose: () => void;
  numOfNoEmailCandidates: number;
  numOfBlockedCandidates: number;
  modalType: 'ALL' | 'SELECTED' | 'INDIVIDUAL';
}

const IExamCheckEmailModal: React.FC<IExamCheckEmailDialogProps> = ({
  modalState,
  onDialogConfirm,
  onDialogClose,
  numOfBlockedCandidates,
  numOfNoEmailCandidates,
  modalType,
}: IExamCheckEmailDialogProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const [buttonDisable, setButtonDisable] = useState<boolean>(false);

  if (modalType === 'INDIVIDUAL') {
    return (
      <Dialog open={modalState} maxWidth="md">
        <DialogContent className={classes.dialogContainer}>
          <DialogTitle>
            {t(
              'components->>IExamCandidateCreate.Candidate account is blocked. Email will not be sent.'
            )}
          </DialogTitle>
        </DialogContent>

        <DialogActions>
          <div className={classes.button}>
            <Button type="submit" onClick={() => onDialogClose()}>
              {t('components->>IExamCandidateCreate.OK')}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog open={modalState} maxWidth="md">
      <DialogTitle>
        {t('components->>IExamCandidateCreate.Proceed to email the rest of the candidates?')}
      </DialogTitle>

      <DialogContent className={classes.dialogContainer}>
        <DialogContent className={classes.dialogContainer}>
          {numOfNoEmailCandidates > 0 ? (
            <DialogContentText>
              {t(
                'components->>IExamCandidateCreate.There are {{numOfNoEmailCandidates}} candidates without email.',
                { numOfNoEmailCandidates }
              )}
            </DialogContentText>
          ) : null}
          {numOfBlockedCandidates > 0 ? (
            <DialogContentText>
              {t(
                'components->>IExamCandidateCreate.There are {{numOfBlockedCandidates}} candidates which are blocked.',
                { numOfBlockedCandidates }
              )}
            </DialogContentText>
          ) : null}
        </DialogContent>
      </DialogContent>

      <DialogActions>
        <div className={classes.button}>
          <Button type="button" variant="text" onClick={() => onDialogClose()}>
            {t('components->>IExamCandidateCreate.Cancel')}
          </Button>
          <Button
            type="submit"
            disabled={buttonDisable}
            onClick={() => {
              setButtonDisable(true);
              onDialogConfirm();
            }}
          >
            {t('components->>IExamCandidateCreate.Proceed')}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default IExamCheckEmailModal;
